// Tab Cliente del dettaglio preventivo PV: composizione card cliente e dati fornitura
import { TabsContent } from '../ui/tabs';
import { CustomerSelectionCard } from './customer-tab/CustomerSelectionCard';
import { SupplyDataCard } from './customer-tab/SupplyDataCard';

export { PLANT_TYPES } from './customer-tab/constants';

export const QuoteCustomerTab = ({
    quote, isEditable, customers, getCustomerName,
    customerMode, setCustomerMode,
    newCustomerData, setNewCustomerData, savingCustomer, onSaveNewCustomer,
    extractingBill, onBillUpload,
    onUpdateSupplyData, onUpdateQuote,
    calculatedPlantData,
}) => (
    <TabsContent value="customer" className="space-y-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <CustomerSelectionCard
                quote={quote}
                isEditable={isEditable}
                customers={customers}
                getCustomerName={getCustomerName}
                customerMode={customerMode}
                setCustomerMode={setCustomerMode}
                newCustomerData={newCustomerData}
                setNewCustomerData={setNewCustomerData}
                savingCustomer={savingCustomer}
                onSaveNewCustomer={onSaveNewCustomer}
                onUpdateQuote={onUpdateQuote}
            />
            <SupplyDataCard
                quote={quote}
                isEditable={isEditable}
                extractingBill={extractingBill}
                onBillUpload={onBillUpload}
                onUpdateSupplyData={onUpdateSupplyData}
                onUpdateQuote={onUpdateQuote}
                calculatedPlantData={calculatedPlantData}
            />
        </div>
    </TabsContent>
);
